import { TypographyProps } from '../../library/Typography';
import { StyledHeading } from './styles';

export type HeadingVariants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface HeadingProps extends Omit<TypographyProps, 'variant'> {
  variant?: HeadingVariants;
  isUppercase?: boolean;
}

export default function Heading(props: HeadingProps) {
  const { variant = 'h2' } = props;

  return <StyledHeading variant={variant} {...props} />;
}
